import * as PasswordConstants from '../../password/constants';

const initialState = {
  isLoading: false,
  error: null,
  success: false
};

export function passwordReset(state = initialState, action) {
  switch (action.type) {
    case PasswordConstants.PASSWORD_RESET_SUBMIT:
      return Object.assign({}, state, {isLoading: true, error: null, success: false});
    case PasswordConstants.PASSWORD_RESET_COMPLETED:
      return Object.assign({}, state, {isLoading: false, error: null, success: action.response.success});
    case PasswordConstants.PASSWORD_RESET_FAILED:
      return Object.assign({}, state, {isLoading: false, success: false, error: action.error});
    case PasswordConstants.PASSWORD_RESET_RESET:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
}
